module.exports = __webpack_public_path__ + "img/box9-24.385611cd.png";